module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4n3r1n2n-4b0513ac77c2dd1b6a1e3dc2ed027904.svg";